import React, { useState } from 'react';

import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import Button from '../../../../../components/Button';
import PreviewCategoryModal from '../../modal/PreviewCategoryModal';
import './CategoryExhibitSaveNavBar.scss';

const CategoryExhibitSaveNavBar = (props) => {
  const { isEditable, setIsEditable, exhibitGeneralCategoryDataSource, exhibitEmphasisCategoryDataSource, onSubmit } =
    props;
  const [isOpen, setIsOpen] = useState(false);

  return (
    <FixedBottomNavBar className="category-exhibit-save-navbar">
      {isEditable ? (
        <div className="button-group">
          <Button
            color="light"
            text="미리보기"
            onClick={() => {
              setIsOpen(true);
            }}
          />
          <Button color="primary" text="저장" onClick={onSubmit} />
        </div>
      ) : (
        <Button
          color="primary"
          text="편집"
          onClick={() => {
            setIsEditable(true);
          }}
        />
      )}
      {isOpen && (
        <PreviewCategoryModal
          setIsOpen={setIsOpen}
          exhibitGeneralCategoryDataSource={exhibitGeneralCategoryDataSource}
          exhibitEmphasisCategoryDataSource={exhibitEmphasisCategoryDataSource}
        />
      )}
    </FixedBottomNavBar>
  );
};

export default CategoryExhibitSaveNavBar;
